import { Input } from "./Field";
import u from "./ui.module.css";

function mergeClass(...parts) {
  return parts.filter(Boolean).join(" ");
}

export function DatePicker({
  value,
  onChange,
  className = "",
  error,
  ...rest
}) {
  return (
    <Input
      type="date"
      value={value || ""}
      onChange={(e) => onChange?.(e.target.value)}
      className={mergeClass(u.dateTimeInput, className)}
      error={error}
      {...rest}
    />
  );
}

export function TimePicker({
  value,
  onChange,
  className = "",
  error,
  step = 60,
  ...rest
}) {
  return (
    <Input
      type="time"
      step={step}
      value={value || ""}
      onChange={(e) => onChange?.(e.target.value)}
      className={mergeClass(u.dateTimeInput, className)}
      error={error}
      {...rest}
    />
  );
}

export function DateTimePicker({
  value,
  onChange,
  className = "",
  error,
  ...rest
}) {
  return (
    <Input
      type="datetime-local"
      value={value || ""}
      onChange={(e) => onChange?.(e.target.value)}
      className={mergeClass(u.dateTimeInput, className)}
      error={error}
      {...rest}
    />
  );
}

export function splitDatetimeLocal(value) {
  if (!value) return { date: "", time: "" };
  const [date, timePart = ""] = String(value).split("T");
  return { date: date || "", time: timePart.slice(0, 5) };
}

export function joinDatetimeLocal(date, time) {
  if (!date) return "";
  const t = time && /^\d{2}:\d{2}/.test(time) ? time.slice(0, 5) : "12:00";
  return `${date}T${t}`;
}

/** Дата и время в двух нативных пикерах — удобнее на телефоне, чем datetime-local */
export function DateTimePickerSplit({
  value,
  onChange,
  className = "",
  dateClassName = "",
  timeClassName = "",
  disabled = false,
}) {
  const { date, time } = splitDatetimeLocal(value);

  return (
    <div className={mergeClass(u.dateTimeSplit, className)}>
      <DatePicker
        value={date}
        disabled={disabled}
        className={dateClassName}
        onChange={(nextDate) => {
          if (!nextDate) {
            onChange?.("");
            return;
          }
          onChange?.(joinDatetimeLocal(nextDate, time || "12:00"));
        }}
        aria-label="Дата"
      />
      <TimePicker
        value={time}
        disabled={disabled || !date}
        className={timeClassName}
        onChange={(nextTime) => {
          if (!date) return;
          onChange?.(joinDatetimeLocal(date, nextTime));
        }}
        aria-label="Время"
      />
    </div>
  );
}
